import { SelectOrganizationAction } from "../actions/SelectOrganization";
import { OrgState } from "../state";

export function selectOrganization(state: OrgState, action: SelectOrganizationAction) {
    const { organization } = action.payload;
    const newState: Partial<OrgState> = {
        currentAvailableAppsSummary: undefined,
        currentOrg: organization,
        currentPaymentSummary: undefined
    };

    return { ...state, ...newState };
}
